import { Component, Input } from '@angular/core';
import { ButtonBaseComponent } from 'app/shared/components/buttons/button-base.component';

@Component({
    ...ButtonBaseComponent.metaData,
    selector: 'app-button-delete',
    templateUrl: './button-delete.component.html',
    styleUrls: ['./button-delete.component.scss'],
    standalone: false
})
export class ButtonDeleteComponent extends ButtonBaseComponent {
  @Input() title = 'COMMON.CARD_DELETE';
  @Input() withText = true;
}
